import React from 'react';
import appParameters from '../../../../utils/AppParameters';
import properties from '../../../../../constants/Properties';
import { ColorPallete } from '../subcomponents/ColorPallete';
import { CustomSlider } from '../../../CustomSlider';

export const BorderStyleArea = React.createClass({
    render() {
        let sliderHeight = properties.STYLING_SLIDER_HEIGHT;
        let menuStyle = {
            position: 'absolute',
            top: this.props.top,
            left: 0,
            width: this.props.width
        };

        let thicknessProperties = {};
        thicknessProperties.topPosition = 2 * this.props.topGap + 2 * this.props.gridSize;
        thicknessProperties.leftPosition = 0;
        thicknessProperties.width = this.props.width;
        thicknessProperties.height = sliderHeight;
        thicknessProperties.backgroundHref = appParameters.RESOURCES_LOCATION() + 'assets/strokeSlider.png';
        thicknessProperties.thumbHref = appParameters.RESOURCES_LOCATION() + 'assets/sliderThumb.png';
        thicknessProperties.thumbSize = properties.STYLING_THUMB_SIZE;
        thicknessProperties.start = 0;
        thicknessProperties.end = 10;
        thicknessProperties.step = 1;
        thicknessProperties.target = this.props.contextTarget;
        thicknessProperties.dispatch = this.props.dispatch;
        thicknessProperties.type = 'change_stroke';
        thicknessProperties.isTextEditorTool = true;

        let idValue;

        if (!this.props.contextTarget.isMindMap)
            idValue = 'lastFocusableObjectForTextEditorTool';

        return (
            <div style={menuStyle}>
                <ColorPallete type={this.props.type} currentColor={this.props.currentColor} executeCommand={this.props.executeCommand} top={0} topGap={this.props.topGap} width={this.props.width} gridSize={this.props.gridSize} contextTarget={this.props.contextTarget} forceUpdateTextEditor={this.props.forceUpdateTextEditor} />
                <CustomSlider id={idValue} properties={thicknessProperties} executeCommand={this.props.executeCommand} />
            </div>
        );
    }
});


/** WEBPACK FOOTER **
 ** ./src/components/menus/textEditorTool/components/subcomponents/BorderStyleArea.js
 **/